module.exports = __webpack_public_path__ + "static/media/flood-plains.739171cb.jpg";